import React from 'react';

interface LogoIconProps {
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * MedNecessity shield + M-checkmark logo mark.
 * Uses currentColor by default so it inherits from parent CSS.
 */
const LogoIcon: React.FC<LogoIconProps> = ({
  size = 32,
  color = 'currentColor',
  className,
  style,
}) => (
  <svg
    viewBox="0 0 36 42"
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    aria-hidden="true"
  >
    <path
      d="M18 1L33 7.5C34.5 8.2 35 9.5 35 11V26C35 33 28 38.5 18 41.5C8 38.5 1 33 1 26V11C1 9.5 1.5 8.2 3 7.5L18 1Z"
      fill={color}
    />
    <path
      d="M10 30V14L18 23L26 14V30"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14 26L18 31L28 19"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default LogoIcon;
